module.exports = __webpack_public_path__ + "img/electronicCircuit.5c4a1b27.jpg";